exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-2d2bbdc2] .el-menu-item:not(.submenu-title-noDropdown){padding:0 !important;text-align:center}[data-v-2d2bbdc2] .el-submenu .el-submenu__title,.el-menu-item.submenu-title-noDropdown[data-v-2d2bbdc2]{padding:0 0 0 0.2rem !important}[data-v-2d2bbdc2] .el-menu-item .svg-icon,[data-v-2d2bbdc2] .el-submenu__title .svg-icon{margin-right:0.13333rem !important}[data-v-2d2bbdc2] .el-submenu__icon-arrow{right:0.13333rem !important}", ""]);

// exports
